module.exports = __webpack_public_path__ + "img/guizhouHints_1.f624ae0a.jpg";